import React, { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M8.89286 7.19631V4.95182C8.89286 3.99161 9.38786 3.06739 10.2246 2.6473C11.6625 1.92714 13.065 2.86335 13.4775 4.07562C13.6307 4.51971 14.0786 4.79578 14.55 4.79578C15.3514 4.79578 15.9525 3.9796 15.6579 3.22344C14.8329 1.03896 12.4168 -0.653426 9.80036 0.246772C7.79679 0.930922 6.53571 2.98339 6.53571 5.14387V7.19631C4.57929 7.19631 3 8.80466 3 10.7971V20.3992C3 22.3916 4.57929 24 6.53571 24H15.9643C17.9207 24 19.5 22.3916 19.5 20.3992V10.7971C19.5 8.80466 17.9207 7.19631 15.9643 7.19631H8.89286ZM17.1429 20.3992C17.1429 21.0594 16.6125 21.5995 15.9643 21.5995H6.53571C5.8875 21.5995 5.35714 21.0594 5.35714 20.3992V10.7971C5.35714 10.137 5.8875 9.59684 6.53571 9.59684H15.9643C16.6125 9.59684 17.1429 10.137 17.1429 10.7971V20.3992Z' />
        </SvgIcon>
    );
});
